import { isInverse } from '@1delta/lender-registry'
import type { TermAdapter } from './index'

/**
 * Inverse Finance (FiRM) — a CDP where interest is PREPAID in DBR tokens.
 *
 * The debt principal is static; the cost is a DBR balance burning down at one
 * DBR per borrowed dollar per year. Running out triggers a permissionless
 * force-replenish at ~54.75 %/yr — repeatable EVERY block, and it freezes
 * withdrawals. There is also no supply side: DOLA is Fed-minted, not deposited.
 */
export const inverseAdapter: TermAdapter = {
  id: 'inverse',
  matches: isInverse,
  profileId: () => 'inverse.firm@v1',
  build: () => ({
    borrow: {
      rate: { kind: 'prepaid', isLocked: false, source: 'oracle' },
      debtShape: 'prepaid',
      exit: {
        earlyRepay: 'free',
        atMaturityCost: 'accrued',
        lateBehaviour: 'none',
        partialAllowed: true,
      },
      liquidation: { trigger: 'price', seizure: 'proportional' },
      counterparty: { kind: 'cdp', solvency: 'overcollateralized' },
      availability: {
        // Every CONTRACT caller must be allowlisted by a 48h governance vote,
        // which is what blocks leverage and other routed flows.
        requires: ['token-approval', 'caller-allowlist'],
      },
    },
    constraints: {
      positionModel: 'escrow',
      positionIdMeaning:
        'A per-user CREATE2 escrow address, computed rather than discovered.',
    },
  }),
}
